import { ReactNode, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Navbar from "./Navbar";
import { Link, useLocation } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Send,
} from "lucide-react";

const Layout = ({
  children,
  title,
  route,
}: {
  children: ReactNode;
  title: string;
  route: string;
}) => {
  const logo = require("../../../assets/images/logo-white.png");

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const [email, setEmail] = useState("");
  const [submitStatus, setSubmitStatus] = useState<
    "idle" | "success" | "error"
  >("idle");

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    const emailRegex = /[^\s@]+@[^\s@]+\.[^\s@]+/;
    if (!emailRegex.test(email)) {
      setSubmitStatus("error");
      return;
    }
    setSubmitStatus("success");
    setEmail("");
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title} - W2ST</title>
        <link rel="canonical" href={`https://w2st.net/${route}`} />
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <footer className="bg-primary900 px-5 py-10 md:p-[64px] text-white">
        <section className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10 border-t border-white/10 pt-10">
            <div>
              <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                <Link
                  to="/"
                  className="cursor-pointer mb-6 md:mb-0 inline-flex items-center gap-3"
                >
                  <img
                    src={logo}
                    className="h-[35px]"
                    alt="Logo of Way2SuccessTutors"
                  />
                  <span className="sr-only">Way2Success Tutors</span>
                </Link>
              </div>
            </div>
            <div>
              <h3 className="text-tmd font-semibold mb-4">Links</h3>
              <ul className="space-y-3 text-white/80 text-tsm">
                <li>
                  <Link className="hover:text-white transition" to="/terms">
                    Terms of Service
                  </Link>
                </li>
                <li>
                  <Link className="hover:text-white transition" to="/policy">
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-tmd font-semibold mb-4">Contact us</h3>
              <ul className="space-y-3 text-white/80 text-tsm">
                <li>
                  <span className="hover:text-white transition">
                    1202 SW 17th Street, Suite 201-191, Ocala, FL 34471 <br />{" "}
                    <span>(Mailing Address)</span>
                  </span>
                </li>
                <li>
                  <span className="hover:text-white transition">
                    +1 (844) 587-7656
                  </span>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="mailto:info@w2st.net"
                    className="hover:text-white transition cursor-pointer"
                  >
                    info@w2st.net
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 border-t border-white/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-white/70 text-tsm">
            <div>
              © {new Date().getFullYear()} Way2Success Tutors. All rights
              reserved.
            </div>
            <div className="flex items-center gap-3 text-white/80">
              <a
                href="https://www.facebook.com/profile.php?id=61592154260661"
                aria-label="Facebook"
                title="Facebook"
                target="_blank"
                className="p-2 rounded-full hover:bg-white/10 transition"
              >
                <Facebook className="h-5 w-5" />
              </a>
              {/* <a
                href="#"
                aria-label="Twitter"
                title="Twitter"
                className="p-2 rounded-full hover:bg-white/10 transition"
              >
                <Twitter className="h-5 w-5" />
              </a> */}
              <a
                href="https://www.instagram.com/waytosuccesstutors/"
                target="_blank"
                aria-label="Instagram"
                title="Instagram"
                className="p-2 rounded-full hover:bg-white/10 transition"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/waytosuccesstutors/"
                target="_blank"
                aria-label="LinkedIn"
                title="LinkedIn"
                className="p-2 rounded-full hover:bg-white/10 transition"
              >
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </section>
      </footer>
    </div>
  );
};

export default Layout;
